var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import styles from './cookie-category-list.component.scss';
import { Component, h } from 'preact';
import CookieCheckbox from '../cookie-checkbox/cookie-checkbox.component';
import CookieStatusService from '../../service/cookie-status.service';
import TranslateService from '../../service/translate.service';
var CookieCategoryList = /** @class */ (function (_super) {
    __extends(CookieCategoryList, _super);
    function CookieCategoryList() {
        var _this = _super.call(this) || this;
        _this.cookieStatusService = CookieStatusService.getInstance();
        _this.state = {
            entries: []
        };
        _this.init();
        _this.checkboxUpdate = _this.checkboxUpdate.bind(_this);
        _this.updateEntries = _this.updateEntries.bind(_this);
        _this.cookieStatusService.subscribe(_this.updateEntries);
        return _this;
    }
    CookieCategoryList.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, this.cookieStatusService.getCookieGroupStatus()];
                    case 1:
                        _a.apply(this, [(_b.entries = _c.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    CookieCategoryList.prototype.checkboxUpdate = function (event, info) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cookieStatusService.toggleCookieGroupStatus(info.cookieCategoryId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.updateEntries()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CookieCategoryList.prototype.updateEntries = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newEntries;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cookieStatusService.getCookieGroupStatus()];
                    case 1:
                        newEntries = _a.sent();
                        this.setState({
                            entries: newEntries
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CookieCategoryList.prototype.render = function () {
        var _this = this;
        return (h("div", { class: "" + styles['cookie-category-list'] }, this.state.entries.map(function (category, index) { return (h(CookieCheckbox, { name: category.languages[TranslateService.getLanguage()].name, id: (category.languages[TranslateService.getLanguage()].name.replace(/ /g, '') + category.id + index.toString()), required: category.required, selected: category.status, info: { cookieCategoryId: category.id }, checkboxUpdate: _this.checkboxUpdate })); })));
    };
    return CookieCategoryList;
}(Component));
export default CookieCategoryList;



//////////////////
// WEBPACK FOOTER
// ./components/cookie-category-list/cookie-category-list.component.tsx
// module id = null
// module chunks = 